export default __webpack_public_path__ + "static/media/Profile_Converter.58c37708.jpg";